module.exports = __webpack_public_path__ + "static/media/customers6.d5bfd583.png";